export default __webpack_public_path__ + "static/media/Thug's Belt of Arcane Death.58a78a44.jpg";